import { CheckIn } from '../types';

export const offlineStorage = {
  async savePendingCheckIn(checkIn: CheckIn): Promise<void> {
    const pendingCheckIns = await this.getPendingCheckIns();
    const newPendingCheckIns = [...pendingCheckIns, checkIn];
    await this.setPendingCheckIns(newPendingCheckIns);
  },

  async getPendingCheckIns(): Promise<CheckIn[]> {
    const stored = localStorage.getItem('pendingCheckIns');
    return stored ? JSON.parse(stored) : [];
  },

  async setPendingCheckIns(checkIns: CheckIn[]): Promise<void> {
    localStorage.setItem('pendingCheckIns', JSON.stringify(checkIns));
  },

  async clearPendingCheckIns(): Promise<void> {
    localStorage.removeItem('pendingCheckIns');
  },

  async syncPendingCheckIns(): Promise<void> {
    const pendingCheckIns = await this.getPendingCheckIns();
    if (pendingCheckIns.length === 0) return;

    try {
      // TODO: Implement actual API call to sync pending check-ins
      await this.clearPendingCheckIns();
    } catch (error) {
      console.error('Failed to sync pending check-ins:', error);
    }
  },
};
